/* eslint-env es2020 */
import PropTypes from 'prop-types';
import { useState } from 'react';

import CookieBannerGC from '@skyscanner-internal/global-components/cookie-banner';
import ConsentBanner from '@skyscanner-internal/global-components/unstable__consent-banner';
import clientLogger from 'saddlebag-logger';

const CookieBanner = ({
  disableScrim = false,
  enableKetchCMP = false,
  isProductionEnv = false,
  logger = undefined,
  strings = undefined,
  ...rest
}) => {
  const [cookieBannerAccepted, setCookieBannerAccepted] = useState(false);
  const isBrowser = globalThis.window !== undefined;

  if (cookieBannerAccepted) {
    return null;
  }

  if (enableKetchCMP) {
    return (
      <ConsentBanner
        isProductionEnv={isProductionEnv}
        onPolicyAcceptClick={() => setCookieBannerAccepted(true)}
        strings={strings}
        logger={isBrowser ? clientLogger : logger}
        disableScrim={disableScrim}
      />
    );
  }

  const cookieBannerGCProps = {
    ...rest,
    isProductionEnv,
    strings,
    logger,
    onPolicyAcceptClick: () => setCookieBannerAccepted(true),
    disableScrim,
  };

  if (isBrowser) {
    cookieBannerGCProps.logger = clientLogger;
  }

  return <CookieBannerGC {...cookieBannerGCProps} />;
};

CookieBanner.propTypes = {
  disableScrim: PropTypes.bool,
  enableKetchCMP: PropTypes.bool,
  isProductionEnv: PropTypes.bool,
  logger: PropTypes.shape({}),
  strings: PropTypes.shape({}),
};

export default CookieBanner;
